import { render } from "./serviceProduct.vue?vue&type=template&id=6a021260&scoped=true&ts=true"
import script from "./serviceProduct.vue?vue&type=script&lang=ts"
export * from "./serviceProduct.vue?vue&type=script&lang=ts"

import "./serviceProduct.vue?vue&type=style&index=0&id=6a021260&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a021260"]])

export default __exports__